import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { hieraApi } from "../lib/api";
import { t, type Lang } from "../lib/i18n";
import { PageEditor } from "../editor/PageEditor";

type Props = { lang: Lang };

export function SharePage({ lang }: Props) {
  const { token = "" } = useParams();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState<unknown>(null);
  const [ttl, setTtl] = useState(0);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    hieraApi.share(token).then((res) => {
      setTitle(res.page.title);
      setBody(res.page.body);
      setTtl(res.ttl);
    }).catch(() => setMissing(true));
  }, [token]);

  if (missing) return <div className="share-miss">{t(lang, "shareGone")}</div>;
  if (!body) return <div className="boot">…</div>;

  const mins = Math.max(1, Math.ceil(ttl / 60));

  return (
    <div className="share-page">
      <p className="share-ttl">{t(lang, "shareLeft")} {mins} {t(lang, "minShort")}</p>
      <div className="doc pad">
        <PageEditor
          pageId=""
          spaceId=""
          initialBody={body}
          initialTitle={title}
          updatedAt=""
          editable={false}
          onTitleChange={() => {}}
          onSaved={() => {}}
          langSavedLabel=""
          langAutosavedLabel=""
        />
      </div>
    </div>
  );
}
